'use client'

import { useLocale } from 'next-intl'
import { useEffect, useRef } from 'react'

import { usePathname } from '@/i18n/routing'

const labels: Record<string, string> = {
  en: 'Advertisement',
  pt: 'Publicidade',
  es: 'Publicidad',
  de: 'Anzeige',
}

/** Explicit placements keep advertising separate from file and download controls. */
export function ContentAd() {
  const locale = useLocale()
  const pathname = usePathname()
  const adRef = useRef<HTMLModElement>(null)
  const requestedRef = useRef<HTMLModElement | null>(null)

  useEffect(() => {
    const element = adRef.current
    // Request this unit only on the production host.
    if (!element || window.location.hostname !== 'weloveconvert.com') return
    if (requestedRef.current === element || element.hasAttribute('data-adsbygoogle-status')) return
    requestedRef.current = element

    try {
      const adWindow = window as Window & {
        adsbygoogle?: { push: (options: Record<string, never>) => void }
      }
      const pendingAds: Record<string, never>[] = []
      adWindow.adsbygoogle = adWindow.adsbygoogle || pendingAds
      adWindow.adsbygoogle.push({})
    } catch {
      // An unavailable ad provider must never interrupt a conversion.
    }
  }, [pathname])

  return (
    <aside aria-label={labels[locale] ?? labels.en} className="mx-auto my-12 w-full max-w-5xl px-6">
      <p className="mb-2 text-center text-xs text-slate-400">{labels[locale] ?? labels.en}</p>
      <ins
        key={pathname}
        ref={adRef}
        className="adsbygoogle block min-h-[100px]"
        data-ad-client="ca-pub-9518786846234420"
        data-ad-slot="8087559295"
        data-ad-format="horizontal"
        data-full-width-responsive="true"
      />
    </aside>
  )
}
